﻿module.exports = function($) {
    return {
        init: function() {
            var addToCollectionPage = $(".addToCollection").length > 0;
            if (addToCollectionPage) this.bindEvents();
        },
        bindEvents: function () {
            $('.addToCollection__collect').on('click', function (e) {
                e.stopPropagation();
                $('.addToCollection__form:visible').hide();
                var button = $(this);
                var resourceId = button.parents('.resource').attr("data-resource-id");
                console.log(resourceId);
                var addToCollectionForm =  button.siblings('.addToCollection__form');

                addToCollectionForm.fadeIn();
                $(".collection", addToCollectionForm).trigger('change');
                $('.addToCollection__form', addToCollectionForm).show();
                addToCollectionForm.siblings('.addToCollection__message').hide();
                $('.resourceId', addToCollectionForm).val(resourceId);
                $('input[type=text]', addToCollectionForm).focus();
            });

            $(".collection").on('change', function () {
                var select = $(this);
                var collectionNameField = $('.newCollection', select.parents('.addToCollection__form'));

                if ($(this).val() != "") {
                    collectionNameField.val("").hide();
                } else {
                    collectionNameField.show().focus();
                }
            });

            $('.addToCollection__form a').on('click', function (e) {
                var addToCollection = $(this).parents('.addToCollection');
                var addToCollectionForm = $('.addToCollection__form', addToCollection);
                var resourceIdField = $('.resourceId', addToCollection);
                var collectionField = $(".collection", addToCollection);
                var collectionNameField = $(".newCollection", addToCollection);

                var resourceId = resourceIdField.val();
                var collectionId = collectionField.val();
                var collectionName = "";
                if (collectionId === "")
                    collectionName = collectionNameField.val();

                if (collectionId != "" || (collectionName && collectionName.trim() != '')) {
                    collectionNameField.removeClass("error");
                    addToCollectionForm.hide();
                    var message = $(".addToCollection__message", addToCollection);
                    var successMsg = $(".success", message);
                    var errorMsg = $(".error", message);
                    successMsg.hide();
                    errorMsg.hide();

                    // Perform and ajax search
                    $.ajax({
                        url: '/umbraco/surface/Member/AddResource/',
                        type: 'POST',
                        traditional: true,
                        dataType: 'json',
                        data: {
                            collectionName: collectionName,
                            collectionId: collectionId,
                            resourceId: resourceId
                        },
                        success: function(data) {
                            // Should return a list of collections on success.
                            // Load up the select list with not values.
                            $(".collection").each(function() {
                                var collectionField = $(this);
                                $('option', collectionField).remove();
                                collectionField.append($('<option>', { value: '', text: 'New' }));
                                $.each(data,
                                    function(i, item) {
                                        collectionField.append($('<option>',
                                        {
                                            value: item.Guid,
                                            text: item.Name
                                        }));
                                    });
                            });
                            successMsg.show();
                        },
                        error: function(result) {
                            errorMsg.show();
                        },
                        complete: function () {
                            message.fadeIn();
                            setTimeout(function() {
                                message.fadeOut();
                            }, 2500);
                        }
                    });
                } else {
                    collectionNameField.addClass("error");
                    collectionNameField.focus();
                }
            });

            $('.addToCollection__form').on('click', function(e) {
                e.stopPropagation();
            });

            $(document).on('click', function (e) {
                var shownAddToCollection = $('.addToCollection__form:visible');
                $('input, select', shownAddToCollection).removeClass('error');
                shownAddToCollection.hide();
            });
        }
    }
}